// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1ipdW","text":"SelectPayment_text__3KvxN","title":"SelectPayment_title__IQ7rR","btn":"SelectPayment_btn__14LAI"};